<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="车型名称"
        v-model="listQuery.name"
      >
      </el-input>
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="车型编号"
        v-model="listQuery.code"
      >
      </el-input>
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="车系名称"
        v-model="listQuery.seriesName"
      >
      </el-input>
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="车系编号"
        v-model="listQuery.seriesCode"
      >
      </el-input>
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="产品编号"
        v-model="listQuery.productCode"
      >
      </el-input>
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="显示名称"
        v-model="listQuery.displayName"
      >
      </el-input>

      <!-- <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.status"
      >
        <el-option label="全部状态" :value="99"> </el-option>
        <el-option label="正常" :value="0"> </el-option>
        <el-option label="冻结" :value="-1"> </el-option>
      </el-select> -->

      <!-- <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.isPreSale"
      >
        <el-option label="预售状态" :value="99"> </el-option>
        <el-option label="非预售" :value="0"> </el-option>
        <el-option label="预售" :value="1"> </el-option>
      </el-select> -->

      <el-select
        style="width: 150px"
        class="filter-item"
        v-if="businessType === 0"
        v-model="listQuery.category"
      >
        <el-option label="车系归属" :value="99"> </el-option>
        <el-option label="王朝" :value="1"> </el-option>
        <el-option label="海洋" :value="2"> </el-option>
      </el-select>

      <el-button
        class="filter-item"
        type="info"
        icon="el-icon-search"
        @click="doSearch"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="doReset"
        >重置</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-refresh"
        @click="doRefreshCache"
        >刷新缓存</el-button
      >
      <!-- <el-button class="filter-item" type="primary" icon="el-icon-plus" @click='showNewDialog'>添加</el-button> -->
      <el-button class="filter-item" icon="el-icon-download" @click="doExport"
        >导出</el-button
      >
      <!-- <el-button class="filter-item" @click="showImportDialog">车型价格导入</el-button>
      <el-button class="filter-item" @click="showImportKmDialog">续航导入</el-button> -->
    </div>
    <el-table
      :data="list"
      v-loading="listLoading"
      fit
      border
      highlight-current-row
      style="width: 100%"
      max-height="600"
    >
      <el-table-column align="left" label="车型编号" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="车系编号" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.seriesCode }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="车系名称" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.seriesName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="公里数" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.officialKm }}KM</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="通用公里数" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.commonKm }}KM</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="款型" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.typicalType }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="车型类别" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.modelType }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="车系归属" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.category | categoryDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="车型名称" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="显示名称" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.displayName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="产品编号" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.productCode }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="指导价" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.officialPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="补贴后价" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.offerPrice }}</span>
        </template>
      </el-table-column>

      <el-table-column align="left" label="是否预售" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.isPreSale ? "预售" : "非预售" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        align="center"
        label="状态"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{
            scope.row.status | statusDisplay
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
          <!-- <el-button size="mini" @click="showOnlineDialog(scope.row)"
            >映射</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog title="添加车型" :visible.sync="newDialogVisible" width="40%">
      <el-form
        ref="newForm"
        :model="newForm"
        :rules="newFormRules"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="产品编号" prop="productCode">
          <el-input
            style="width: 200px"
            v-model="newForm.productCode"
            placeholder="产品编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="车型编号" prop="code">
          <el-input
            style="width: 120px"
            v-model="newForm.code"
            placeholder="车型编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="车型名称" prop="name">
          <el-input
            style="width: 200px"
            v-model="newForm.name"
            placeholder="车型名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示名称">
          <el-input
            style="width: 200px"
            v-model="newForm.displayName"
            placeholder="显示名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="车系" prop="seriesCode">
          <el-select
            style="width: 200px"
            class="filter-item"
            filterable
            v-model="newForm.seriesCode"
          >
            <el-option
              v-for="item in seriesRecords"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="颜色" prop="colors">
          <el-input type="textarea" v-model="newForm.colors"></el-input>
          多个颜色以逗号分隔
        </el-form-item>
        <el-form-item label="是否预售">
          <el-switch v-model="newForm.isPreSale"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="newDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doAdd">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑物料配置" :visible.sync="editDialogVisible" width="40%">
      <el-form
        ref="editForm"
        :model="editData"
        :rules="newFormRules"
        label-position="right"
        label-width="120px"
      >
        <!-- <el-form-item label="产品编号" prop="productCode">
          <el-input
            style="width: 200px"
            v-model="editData.productCode"
            placeholder="产品编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="车型编号" prop="code">
          <el-input
            style="width: 120px"
            v-model="editData.code"
            placeholder="车型编号"
          ></el-input>
        </el-form-item> -->
        
        <!-- <el-form-item label="显示名称">
          <el-input
            style="width: 200px"
            v-model="editData.displayName"
            placeholder="显示名称"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="车系编号" prop="seriesCode">
          <el-select
            style="width: 200px"
            class="filter-item"
            filterable
            v-model="editData.seriesCode"
          >
            <el-option
              v-for="item in seriesRecords"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="车系编号" prop="seriesCode">
          <el-input
            style="width: 200px"
            v-model="editData.seriesCode"
            placeholder="车系编号"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="车系名称" prop="seriesName">
          <el-input
            style="width: 200px"
            v-model="editData.seriesName"
            placeholder="车系名称"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="车型名称" prop="name">
          <el-input
            style="width: 200px"
            v-model="editData.name"
            placeholder="车型名称"
            disabled
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="颜色" prop="colors">
          <el-input type="textarea" v-model="editData.colors"></el-input>
          多个颜色以逗号分隔
        </el-form-item>
        <el-form-item label="是否预售">
          <el-switch v-model="editData.isPreSale"> </el-switch>
        </el-form-item> -->

        <el-form-item label="状态">
          <el-col :span="8">
            <el-select
              style="width: 200px"
              class="filter-item"
              v-model="editData.status"
            >
              <el-option label="正常" :value="0"> </el-option>
              <el-option label="冻结" :value="-1"> </el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdate">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="映射配置" :visible.sync="onlineDialogVisible" width="40%">
      <el-form
        ref="editForm"
        :model="editData"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="车型编号">
          {{ editData.code }}
        </el-form-item>
        <el-form-item label="车型名称">
          {{ editData.name }}
        </el-form-item>
        <el-form-item label="车系编号">
          {{ editData.seriesCode }}
        </el-form-item>
        <el-form-item label="车系名称">
          {{ editData.seriesName }}
        </el-form-item>
        <el-form-item
          v-for="(item, index) in editData.mappings"
          :key="index"
          :label="item.name"
        >
          <el-input
            style="width: 350px"
            v-model="item.code"
            placeholder="映射编号"
          ></el-input>
          <!-- <el-input style="width: 200px" v-model="item.mapName" placeholder="映射名称"></el-input> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onlineDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdateOnlines">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="车型价格导入"
      :visible.sync="importDialogVisible"
      width="30%"
    >
      <div style="text-align: center">
        <el-upload
          class="upload-demo"
          accept=".xlsx"
          drag
          action
          :file-list="uploadFiles"
          :http-request="uploadRequest"
          :limit="1"
          :on-success="uploadSuccess"
          :on-remove="uploadRemove"
          :before-upload="uploadBefore"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
        </el-upload>
        <div>
          <a
            href="https://zhizhu-high.oss-cn-shenzhen.aliyuncs.com/zhizhu/template/%E8%BD%A6%E5%9E%8B%E4%BB%B7%E6%A0%BC%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
            class="table-href"
            >下载模版</a
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideImportDialog">取消</el-button>
        <el-button type="primary" :loading="uploadLoading" @click="doImport"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="续航导入"
      :visible.sync="importDialogKmVisible"
      width="30%"
    >
      <div style="text-align: center">
        <el-upload
          class="upload-demo"
          accept=".xlsx"
          drag
          action
          :file-list="uploadFiles2"
          :http-request="uploadRequest"
          :limit="1"
          :on-success="uploadSuccess2"
          :on-remove="uploadRemove2"
          :before-upload="uploadBefore"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
        </el-upload>
        <div>
          <a
            href="https://zhizhu-high.oss-cn-shenzhen.aliyuncs.com/zhizhu/v2/temp/%E7%BB%AD%E8%88%AA%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
            class="table-href"
            >下载模版</a
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideImportDialog2">取消</el-button>
        <el-button type="primary" :loading="uploadLoading2" @click="doImport2"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";
import oss from "@/utils/ali-oss";

export default {
  name: "VehicleSpecList",
  data() {
    return {
      businessType: store.getters.user.businessType,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        name: "",
        code: "",
        seriesCode: "",
        seriesName: "",
        status: 99,
        isPreSale: 99,
        productCode: "",
        displayName: "",
        category: 99,
      },
      importDialogVisible: false,
      importDialogKmVisible: false,
      uploadFiles: [],
      uploadFile: "",
      uploadFiles2: [],
      uploadFile2: "",
      uploadLoading: false,
      uploadLoading2: false,
      newDialogVisible: false,
      newForm: {
        name: "",
        code: "",
        seriesId: "",
        colors: "",
        isPreSale: false,
        productCode: "",
        displayName: "",
      },
      editDialogVisible: false,
      editData: {},

      newFormRules: {
        productCode: [
          {
            required: true,
            message: "请输入产品编号",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入车型编码",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入车型名称",
            trigger: "blur",
          },
        ],
        seriesCode: [
          {
            required: true,
            message: "请选择车系",
            trigger: "blur",
          },
        ],
        colors: [
          {
            required: true,
            message: "请输入车型颜色",
            trigger: "blur",
          },
        ],
      },
      onlineDialogVisible: false,
      seriesRecords: [],
    };
  },
  filters: {
    categoryDisplay(type) {
      const map = {
        1: "王朝",
        2: "海洋",
        3: "领汇"
      };
      return map[type];
    },
    statusFilter(status) {
      const statusMap = {
        0: "success",
        1: "info",
      };
      return statusMap[status];
    },
    statusDisplay(status) {
      const statusMap = {
        0: "正常",
        "-1": "冻结",
      };
      return statusMap[status];
    },
    onlineOrderDisplay(flag) {
      const map = {
        true: "开放",
        false: "限制",
      };
      return map[flag];
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  activated() {
    if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
      this.doReset();
      this.$route.meta.redraw = false;
    }
    if (
      this.$route.meta.hasOwnProperty("refresh") &&
      this.$route.meta.refresh
    ) {
      this.getList();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    this.doReset();
    this.retrieveSeries();
  },
  methods: {
    doReset() {
      this.list = [];
      this.total = 0;
      this.listLoading = true;
      this.listQuery = {
        page: 1,
        limit: 10,
        salesCenter: "",
        name: "",
        code: "",
        seriesCode: "",
        seriesName: "",
        status: 99,
        isPreSale: 99,
        productCode: "",
        displayName: "",
        category: 99,
      };
      this.doSearch();
    },
    retrieveSeries() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/seriesList", {
          pageStart: 0,
          pageCount: 1000,
          status: 0,
          useMap: false,
          needReport: 99,
          category: 99,
        })
        .then(function (response) {
          parent.seriesRecords = response.data.data;
        });
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/specList", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          status: this.listQuery.status,
          name: this.listQuery.name,
          code: this.listQuery.code,
          seriesName: this.listQuery.seriesName,
          seriesCode: this.listQuery.seriesCode,
          isPreSale: this.listQuery.isPreSale,
          productCode: this.listQuery.productCode,
          displayName: this.listQuery.displayName,
          category: this.listQuery.category,
          isExport: false,
        })
        .then(function (response) {
          parent.listLoading = false;
          parent.list = response.data.data;
          parent.total = response.data.total;
        })
        .catch(() => {
          parent.listLoading = false;
        });
    },
    doExport() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$httpAuth
        .post("/v1/backendVehicleRpc/specList", {
          status: this.listQuery.status,
          name: this.listQuery.name,
          code: this.listQuery.code,
          seriesName: this.listQuery.seriesName,
          seriesCode: this.listQuery.seriesCode,
          isPreSale: this.listQuery.isPreSale,
          productCode: this.listQuery.productCode,
          displayName: this.listQuery.displayName,
          category: this.listQuery.category,
          isExport: true,
        })
        .then(function (response) {
          setTimeout(() => {
            loading.close();
            var a = document.createElement("a");
            a.href = response.data.file;
            a.click();
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    showNewDialog() {
      this.newDialogVisible = true;
      this.newForm = {
        code: "",
        name: "",
        seriesId: "",
        colors: "",
        isPreSale: false,
        productCode: "",
        displayName: "",
      };
      if (this.$refs["newForm"]) {
        this.$refs["newForm"].resetFields();
      }
    },
    showEditDialog(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },
    doAdd() {
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          this.$httpAuth
            .post("/v1/backendVehicleRpc/addSpec", this.newForm)
            .then(function (response) {
              parent.getList();
              parent.$notify({
                title: "提示",
                message: "保存成功",
              });
              parent.newDialogVisible = false;
            });
        }
      });
    },
    doUpdate() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          this.$httpAuth
            .post("/v1/backendVehicleRpc/updateSpecSkuStatus", {
              id: this.editData.skuId,
              status: this.editData.status,
            })
            .then(function (response) {
              parent.getList();
              parent.$notify({
                title: "提示",
                message: "保存成功",
              });
              parent.editDialogVisible = false;
            });
        }
      });
    },
    showImportDialog() {
      this.importDialogVisible = true;
      this.uploadLoading = false;
    },
    showImportKmDialog() {
      this.importDialogKmVisible = true;
      this.uploadLoading2 = false;
    },
    hideImportDialog() {
      this.uploadFiles = [];
      this.uploadFile = "";
      this.importDialogVisible = false;
    },
    hideImportDialog2() {
      this.uploadFiles2 = [];
      this.uploadFile2 = "";
      this.importDialogKmVisible = false;
    },
    uploadBefore(file) {
      if (
        file.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.$message.error("请上传xlsx格式文件!");
        return false;
      }
    },
    uploadRequest(option) {
      oss.ossUploadFile(option);
    },
    uploadSuccess(res, file) {
      this.uploadFile = res;
    },
    uploadSuccess2(res, file) {
      this.uploadFile2 = res;
    },
    uploadRemove(file, fileList) {
      this.uploadFile = "";
    },
    uploadRemove2(file, fileList) {
      this.uploadFile2 = "";
    },
    doImport() {
      if (this.uploadFile == "") {
        this.$message({
          message: "请选择导入文件",
          type: "warning",
        });
        return;
      }
      var parent = this;
      parent.uploadLoading = true;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/importPrice", {
          fileUrl: this.uploadFile,
        })
        .then(function (response) {
          parent.uploadLoading = false;
          console.log(response.data);
          parent.$notify({
            title: "",
            dangerouslyUseHTMLString: true,
            message: "导入成功",
          });
          parent.hideImportDialog();
          parent.doReset();
        })
        .catch(function (error) {
          parent.uploadLoading = false;
          return;
        });
    },
    doImport2() {
      if (this.uploadFile2 == "") {
        this.$message({
          message: "请选择导入文件",
          type: "warning",
        });
        return;
      }
      var parent = this;
      parent.uploadLoading = true;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/importKm", {
          fileUrl: this.uploadFile2,
        })
        .then(function (response) {
          parent.uploadLoading = false;
          parent.$notify({
            title: "",
            dangerouslyUseHTMLString: true,
            message: "导入成功",
          });
          parent.hideImportDialog2();
          parent.doReset();
        })
        .catch(function (error) {
          parent.uploadLoading2 = false;
          return;
        });
    },
    showOnlineDialog(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      this.onlineDialogVisible = true;
    },

    doUpdateOnlines() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/updateSpecMapping", {
          id: this.editData.id,
          records: this.editData.mappings,
        })
        .then(function (response) {
          console.log(response.data);
          parent.$notify({
            title: "提示",
            message: "保存成功",
          });
          parent.onlineDialogVisible = false;
          parent.getList();
        });
    },
    toDelete(id) {
      this.$confirm("是否删除该数据?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var parent = this;
        this.$httpAuth
          .post("/v1/backendVehicleRpc/deleteSpec", {
            id: id,
          })
          .then(function (response) {
            parent.$message({
              message: "删除成功",
              type: "success",
            });
            parent.getList();
          });
      });
    },
    doRefreshCache() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/refreshSpecCache", {})
        .then(function (response) {
          parent.$message({
            message: "刷新缓存成功",
            type: "success",
          });
        });
    },
  },
};
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
